import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { NOTIFICATIONS_PARTNERS } from '@/app/data/notifications_constants';
import { PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';

export default function useActivityNotificationItem(notification) {
  const store = useStore();
  const route = useRoute();

  const clients = computed(() => store.getters.clients);
  const customers = computed(() => store.getters.customers);
  const employees = computed(() => store.getters.employees);
  const partners = computed(() => store.getters.partners);
  const current_profile = computed(() => store.getters.current_profile);
  const projects = computed(() => store.getters.projects);

  const notifier = computed(() => {
    if (!notification.value) return null;
    if (notification.value.attributes.key === NOTIFICATIONS_PARTNERS.UNIT_VISIBLED) {
      return null;
    }

    switch (notification.value.attributes.notifier_type) {
      case PROFILE_TYPES.EMPLOYEE: {
        return employees.value[notification.value.attributes.notifier_id];
      }
      case PROFILE_TYPES.CUSTOMER: {
        return customers.value[notification.value.attributes.notifier_id];
      }
      case PROFILE_TYPES.PARTNER: {
        return partners.value[notification.value.attributes.notifier_id];
      }
      case RECORD_TYPE.CLIENT: {
        if (current_profile.value.type === PROFILE_TYPES.CUSTOMER) {
          return clients.value[notification.value.attributes.parameters.client_id];
        }
        return null;
      }
      default: {
        return null;
      }
    }
  });

  const project = computed(() => {
    if (!notification.value) return null;
    return projects.value[notification.value.attributes.project_id];
  });

  const project_name = computed(() => _.get(project.value, 'attributes.name'));

  const project_sup = computed(() => _.get(project.value, 'attributes.skip_unit'));

  const params = computed(() => {
    if (!notification.value) return {};
    const client_hash = { client_id: route.params.client_id };
    return { ...client_hash, ...notification.value.attributes.parameters };
  });

  return {
    notifier,
    project,
    project_name,
    project_sup,
    params,
  };
}
